import { render, staticRenderFns } from "./RelatorioClientesTotais.vue?vue&type=template&id=6918e015"
import script from "./RelatorioClientesTotais.vue?vue&type=script&lang=js"
export * from "./RelatorioClientesTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports